import { render, staticRenderFns } from "./DetailsAgendada.vue?vue&type=template&id=b7591264&scoped=true"
import script from "./DetailsAgendada.vue?vue&type=script&lang=js"
export * from "./DetailsAgendada.vue?vue&type=script&lang=js"
import style0 from "./DetailsAgendada.vue?vue&type=style&index=0&id=b7591264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7591264",
  null
  
)

export default component.exports